<script setup lang="ts">
import { ref } from 'vue'
import { passwordService } from '@/core/services'
import { flashMessage } from '@/utils/FlashMessages'
import { handleError } from '@/utils/ErrorHandler'
import { useRoute } from 'vue-router'
import router from '@/router'
import PasswordInput from '@/components/input/PasswordInput.vue'

const password = ref('')
const passwordConfirm = ref('')

const passwordResetToken = useRoute().query.token as string

const submit = () => {
  if (password.value !== passwordConfirm.value) {
    flashMessage.error('Passwords do not match')
    return
  }

  passwordService
    .confirmReset(passwordResetToken, password.value)
    .then(() => {
      flashMessage.success('Your password has been reset. You can now login with your new password.')
      router.push({ name: 'login' })
    })
    .catch(handleError)
}
</script>

<template>
  <div class="container">
    <form novalidate>
      <h3>Reset password</h3>

      <div class="form-group">
        <PasswordInput v-model="password" :name="'password'" :id="'password'" :placeholder="'Password'" :required="true" />

        <PasswordInput
          v-model="passwordConfirm"
          :name="'passwordConfirm'"
          :id="'passwordConfirm'"
          :placeholder="'Confirm password'"
          :required="true" />
      </div>

      <button class="submit-button" type="button" @click="submit">Reset password</button>
    </form>
  </div>
</template>

<style scoped lang="scss">
@import '@/assets/styles/input.scss';
@import '@/assets/styles/form.scss';
</style>
